// src/scene/AmbientParticles.tsx
/**
 * Ambient Particles
 *
 * Floating particles using drei's Sparkles and Stars
 * for atmospheric depth and visual interest.
 */

import { Sparkles, Stars } from '@react-three/drei'
import { palette } from './tokens'

interface AmbientParticlesProps {
  /** Show sparkles around avatar */
  sparkles?: boolean
  /** Show background stars */
  stars?: boolean
  /** Sparkle color */
  sparkleColor?: string
  /** Sparkle count */
  sparkleCount?: number
}

export function AmbientParticles({
  sparkles = true,
  stars = true,
  sparkleColor = palette.primary[500],
  sparkleCount = 40,
}: AmbientParticlesProps) {
  return (
    <>
      {/* Floating sparkles near avatar */}
      {sparkles && (
        <Sparkles
          count={sparkleCount}
          scale={[4, 3, 4]}
          position={[0, 0.5, 0]}
          size={1.5}
          speed={0.3}
          opacity={0.4}
          color={sparkleColor}
          noise={0.5}
        />
      )}

      {/* Background stars for depth */}
      {stars && (
        <Stars
          radius={50}
          depth={50}
          count={1000}
          factor={2}
          saturation={0.2}
          fade
          speed={0.5}
        />
      )}
    </>
  )
}

export default AmbientParticles
